import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";

const columns = [
  { field: "id", headerName: "순번", width: 0 },
  { field: "carrierCode", headerName: "항공사코드", width: 50 },
  { field: "dateArray", headerName: "날짜", width: 100 },
];

export default function SphTabList({ retValue, retData }) {
  const [data, setData] = useState([]);
  useEffect(() => {
    console.log(retData);
  }, [retData]);
  return <Box></Box>;
}
